import React, { useRef, useEffect } from 'react';
import classnames from 'classnames';
import { shape, number, func, arrayOf, string, bool, element } from 'prop-types';
import useKeyPress from '../Hooks/useKeyPress.js';
import DDLOption from './DDLOption.js';
import { Navigate } from '../Helpers/Utilities.js';
import styles from '../styles.module.css.js';

/* eslint-disable import/extensions */
var SearchResultsList = function SearchResultsList(props) {
  var cursor = props.cursor,
    setCursor = props.setCursor,
    searchResults = props.searchResults,
    isFocus = props.isFocus,
    ignoreHover = props.ignoreHover,
    setIgHover = props.setIgHover,
    onSelect = props.onSelect,
    onPressEnter = props.onPressEnter,
    setSuggest = props.setSuggest,
    embedded = props.embedded,
    id = props.id,
    trailingComponent = props.trailingComponent,
    CustomDDLOption = props.CustomDDLOption,
    isHistory = props.isHistory;
  var downPress = useKeyPress('ArrowDown');
  var upPress = useKeyPress('ArrowUp');
  var enterPress = useKeyPress('Enter', isFocus);
  var escPress = useKeyPress('Escape');
  var optionRef = useRef();
  var scrollToView = function scrollToView() {
    return setTimeout(function () {
      var _optionRef$current;
      return optionRef === null || optionRef === void 0 ? void 0 : (_optionRef$current = optionRef.current) === null || _optionRef$current === void 0 ? void 0 : _optionRef$current.scrollIntoView();
    }, 75);
  };
  var DDLComponent = isHistory ? DDLOption : CustomDDLOption || DDLOption;
  useEffect(function () {
    if (isFocus && searchResults !== null && searchResults !== void 0 && searchResults.length && downPress) {
      setIgHover(true);
      setCursor(function (cs) {
        return Navigate.down(cs, searchResults);
      });
      scrollToView();
    }
  }, [downPress]);
  useEffect(function () {
    if (isFocus && searchResults !== null && searchResults !== void 0 && searchResults.length && upPress) {
      setIgHover(true);
      setCursor(function (cs) {
        return Navigate.up(cs, searchResults);
      });
      scrollToView();
    }
  }, [upPress]);
  useEffect(function () {
    if (isFocus && enterPress) {
      var _Object$keys, _searchResults$cursor, _searchResults$cursor2;
      if ((_Object$keys = Object.keys(cursor)) !== null && _Object$keys !== void 0 && _Object$keys.length) onPressEnter(searchResults === null || searchResults === void 0 ? void 0 : (_searchResults$cursor = searchResults[cursor === null || cursor === void 0 ? void 0 : cursor.type]) === null || _searchResults$cursor === void 0 ? void 0 : (_searchResults$cursor2 = _searchResults$cursor.data) === null || _searchResults$cursor2 === void 0 ? void 0 : _searchResults$cursor2[cursor === null || cursor === void 0 ? void 0 : cursor.item]);else onPressEnter();
    }
  }, [enterPress]);
  useEffect(function () {
    if (isFocus && escPress) {
      setSuggest(false);
    }
  }, [escPress]);
  var ddlOptions = searchResults === null || searchResults === void 0 ? void 0 : searchResults.map(function (_ref, idx) {
    var _ref$type = _ref.type,
      type = _ref$type === void 0 ? null : _ref$type,
      data = _ref.data;
    var header = type ? /*#__PURE__*/React.createElement(DDLComponent, {
      option: type,
      header: true,
      key: "".concat(id, "_header_").concat(type)
    }) : null;
    var optionsList = data.map(function (option, jdx) {
      var _option$value;
      return /*#__PURE__*/React.createElement(DDLComponent, {
        onSelect: onSelect,
        uid: {
          type: idx,
          item: jdx
        },
        option: option,
        ignoreHover: ignoreHover,
        key: "opt_".concat(id, "_").concat(option !== null && option !== void 0 && option.value ? option === null || option === void 0 ? void 0 : (_option$value = option.value) === null || _option$value === void 0 ? void 0 : _option$value.replaceAll(' ', '-') : ''),
        optionRef: optionRef,
        cursor: cursor
      });
    });
    return isFocus ? /*#__PURE__*/React.createElement(React.Fragment, {
      key: "".concat(id, "_section_").concat(type)
    }, header, optionsList) : null;
  });
  return searchResults !== null && searchResults !== void 0 && searchResults.length || trailingComponent ? /*#__PURE__*/React.createElement("div", {
    key: "search-results-ddl-".concat(id),
    role: "menu",
    className: classnames(styles['results-dropdown'], !embedded ? '' : styles['results-dropdown-header'])
  }, searchResults !== null && searchResults !== void 0 && searchResults.length ? ddlOptions : null, trailingComponent || null) : null;
};
SearchResultsList.defaultProps = {
  cursor: {
    item: 0,
    type: 0
  },
  setCursor: function setCursor() {},
  searchResults: [],
  isFocus: false,
  ignoreHover: false,
  setIgHover: function setIgHover() {},
  onSelect: function onSelect() {},
  onPressEnter: function onPressEnter() {},
  setSuggest: function setSuggest() {},
  embedded: false,
  id: '',
  trailingComponent: function trailingComponent() {},
  CustomDDLOption: {},
  isHistory: false
};
SearchResultsList.propTypes = {
  cursor: shape({
    item: number,
    type: number
  }),
  setCursor: func,
  searchResults: arrayOf(shape({
    type: string,
    data: arrayOf(shape({
      value: string,
      label: string
    }))
  })),
  isFocus: bool,
  ignoreHover: bool,
  setIgHover: func,
  onSelect: func,
  onPressEnter: func,
  setSuggest: func,
  embedded: bool,
  id: string,
  trailingComponent: func,
  CustomDDLOption: element,
  isHistory: bool
};

export { SearchResultsList as default };
